import AdditionalOfficeCard from "./AdditionalOfficeCard";

export default function AdditionalOfficesSection({ dir, additionalOffices }) {
  const {
    informationBank,
    publicRelation,
    nationalCenter,
    humanResources,
  } = additionalOffices;

  return (
    <div className="col-12 col-lg-6">
      <div className="cont-info">
        <AdditionalOfficeCard
          dir={dir}
          titleId="to-request-data-or-copy-papers-from-prints-or-register-in-website"
          office={informationBank}
        />
        <AdditionalOfficeCard
          dir={dir}
          titleId="for-media-communication"
          office={publicRelation}
        />
        <AdditionalOfficeCard
          dir={dir}
          titleId="for-training-capacity-building-services"
          office={nationalCenter}
        />
        <AdditionalOfficeCard
          dir={dir}
          office={humanResources}
          showTitle={false}
        />
      </div>
    </div>
  );
}
